module.exports = __webpack_public_path__ + "static/media/atm.fa42fe81.svg";